import $ from 'jquery';

class ImageCredits {
  init() {
    this.creditsBtn = $('.js-image-credits-btn');

    if (this.creditsBtn.length) {
      this.creditsBtn.on('click', e => {
        e.preventDefault();
        const btn = $(e.currentTarget);
        const text = btn.parent().find('.js-image-credits-text');

        if (text.length) {
          text.toggleClass('is-open');
        }
      });
    }
  }
}

export default ImageCredits;



// WEBPACK FOOTER //
// ./src/scripts/modules/image-credits.js